import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ManagementData } from '../../../interfaces/management-data';
import { AddressData } from '../../../interfaces/address-data';
import { InventarProvider } from '../../../providers/inventar';
import { ArraytostringPipe } from '../../pipes/arraytostring';
import { Api } from '../../../providers/api/api';
import {ConfigurationService} from '../../../providers/configuration.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ManagementDetailsComponent component.
 */
@Component({
  selector: 'management-details',
  templateUrl: 'management-details.html',
  providers: [InventarProvider, ArraytostringPipe],
  styleUrls: ['./management-details.scss']
})
export class ManagementDetailsComponent implements OnInit {
  riskLevelOpt: { key: any; value: any; }[] = [];
  deviceCallOpt: { key: string; value: any; }[] = [];
  deviceTypeOpt: { key: string; value: any; }[] = [];
  optionBillingType: { key: any; value: any; }[] = [];
  optionTermination: { key: boolean; value: any; }[] = [];
  optionContactType: { key: string; value: any; }[] = [];

  constructor(private inventarProvider: InventarProvider, 
    private configurationService: ConfigurationService, private api: Api,
    private translate:TranslateService) {
    this.inventarProvider.setUrl(this.configurationService.getValue('inventarDataServer'));

    if (this.inventarProvider.getInventarLoginData() !== false) {
      this.isInventarLogin = true;
    }
  }

  async ngOnInit() {
    this.riskLevelOpt = [
      {key: this.translate.instant('Unknown'), value: this.translate.instant('Unknown')},
      {key: '1', value: '1'},
      {key: '2', value: '2'},
      {key: '3', value: '3'}
    ];
  
    this.deviceCallOpt = [
      {key: 'ja', value: this.translate.instant('YES')},
      {key: 'nein', value: this.translate.instant('NO')},
    ];
  
    this.deviceTypeOpt = [
      {key: 'Unbekannt', value: this.translate.instant('Unknown')},
      {key: 'Funksender', value: this.translate.instant('RadioTransmitter')},
      {key: 'NEAT NEO NG', value: 'NEAT NEO NG'},
      {key: 'NEAT NEO GSM', value: 'NEAT NEO GSM'},
      {key: 'NEAT NEMO', value: 'NEAT NEMO'},
      {key: 'NEAT NOVO', value: 'NEAT NOVO'},
      {key: 'NEAT NOVO GO', value: 'NEAT NOVO GO'},
      {key: 'AMG NR-03', value: 'AMG NR-03'}
    ];
  
    this.optionBillingType = [
      {key: '', value: this.translate.instant('Unknown')},
      {key: this.translate.instant('SelfPayer'), value: this.translate.instant('SelfPayer')},
      {key: this.translate.instant('HealthInsurance'), value: this.translate.instant('HealthInsurance')},
    ]
  
    this.optionTermination = [
      {key: false, value: this.translate.instant('NO')},
      {key: true, value: this.translate.instant('YES')},
    ];
  
    this.optionContactType = [
      {key: '1', value: this.translate.instant('BasicPackage')},
      {key: '2', value: this.translate.instant('KeyPackage')},
      {key: '3', value: this.translate.instant('ComfortPackage')},
    ];
  }

  activeRadioListener = true;

  @Input()
  management: ManagementData;

  @Input()
  address: AddressData;

  @Input()
  transmitterId: string;

  @Input()
  serienNr: string;

  @Output()
  transmitterChange = new EventEmitter();

  @Output()
  serienNrChange = new EventEmitter();

  @Input()
  isEdit: boolean;

  

  isInventarLogin = false;
  searchText = '';
  findInventar: any;

  changeTransMitterId(event) {
    this.transmitterChange.emit(event);
    this.transmitterId = event;
  }

  changeSerienNr(event) {
    this.serienNrChange.emit(event);
    this.serienNr = event;
  }

  addPerson(address: AddressData): Promise<any> {

    return new Promise((resolve, reject) => {
      const personData = {
        name: address.lastname + ', ' + address.firstname,
        img: '',
        street: address.street,
        zip: address.zip,
        city: address.city,
        phoneNumber: '',
        email: '',
        personNum: '',
        type: 'person',
        _id: 'person-' + this.inventarProvider.guid()
      };

      this.inventarProvider.postData(personData).subscribe({next:(resp) => {
        resolve(resp);
      }, error:(err) => {
        reject(err);
      }});

    });
  }

  takeOverInventar() {
    let findPerson: any = false;
    this.inventarProvider.getPerson().then((data) => {

          data.rows.forEach((row) => {
            if (row.doc.name.indexOf(this.address.firstname) !== -1 && row.doc.name.indexOf(this.address.lastname) !== -1) {
              findPerson = row;
            }
          });

          if (findPerson) {
            this.findInventar.doc.person = findPerson.doc._id;
            this.inventarProvider.putItem(this.findInventar.doc).then((resp) => {
              this.management.serienNr = this.searchText;
              this.findInventar = null;
            }).catch((err) => {
              debugger;
            });

          } else {
            this.addPerson(this.address).then((resp) => {
              this.findInventar.doc.person = resp.id;
              this.inventarProvider.putItem(this.findInventar.doc).then(() => {
                this.management.serienNr = this.searchText;
                this.findInventar = null;
              }).catch((err) => {
                debugger;
              });
            });
          }

        });
  }

  searchInventar() {

    this.inventarProvider.searchEan(this.searchText).then((data) => {

      if (!data.rows.length) {
        alert('kein Gerät gefunden');
      } else {
        this.findInventar = data.rows[0];


      }
    }).catch((err) => {
      debugger;
    });
  }

  setSearchText(text: string) {
    this.searchText = text;
  }

  setRadioCode(data) {
    this.transmitterId = data.transmitterId;
    if (this.management.radioReceiver) {
      if (this.management.radioReceiver.indexOf(data.dtect) === -1) {
        if (this.management.radioReceiver instanceof Array) {
          (this.management.radioReceiver as any) = this.management.radioReceiver.join(',');
          (this.management.radioReceiver as any) += ',' + data.dtect;
        }
      }
    } else {
      this.management.radioReceiver = [data.dtect];
    }
  }

  setRadioListener() {
    this.api.socket.on('incoming:transmitterData', this.setRadioCode.bind(this));
    this.activeRadioListener = false;

    setTimeout(() => {
      this.api.socket.removeListener('incoming:transmitterData');
      this.activeRadioListener = true;
    }, 7000);

  }

}
